// extracted by mini-css-extract-plugin
export var inactive = "skill-list-module--inactive--tcYyo";
export var notRelatedSkillsContainer = "skill-list-module--notRelatedSkillsContainer--GLki7";
export var relatedSkillsContainer = "skill-list-module--relatedSkillsContainer--GQSbF";
export var relatedTitle = "skill-list-module--relatedTitle--WTy0t";